import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchSkills = createAction(actionTypes.FETCH_SKILLS_REQUEST);
export const fetchSkillsSuccess = createAction(actionTypes.FETCH_SKILLS_SUCCESS);
export const fetchSkillsFailure = createAction(actionTypes.FETCH_SKILLS_FAILURE);

export const fetchSkillsNext = createAction(actionTypes.FETCH_SKILLS_NEXT_REQUEST);
export const fetchSkillsNextSuccess = createAction(actionTypes.FETCH_SKILLS_NEXT_SUCCESS);
export const fetchSkillsNextFailure = createAction(actionTypes.FETCH_SKILLS_NEXT_FAILURE);

export const updateSkill = createAction(actionTypes.UPDATE_SKILL_REQUEST);
export const updateSkillSuccess = createAction(actionTypes.UPDATE_SKILL_SUCCESS);
export const updateSkillFailure = createAction(actionTypes.UPDATE_SKILL_FAILURE);

export const fetchMasterData = createAction(actionTypes.FETCH_MASTER_DATA_REQUEST);
export const fetchMasterDataSuccess = createAction(actionTypes.FETCH_MASTER_DATA_SUCCESS);
export const fetchMasterDataFailure = createAction(actionTypes.FETCH_MASTER_DATA_FAILURE);

export const updateMasterData = createAction(actionTypes.UPDATE_MASTER_DATA_REQUEST);
export const updateMasterDataSuccess = createAction(actionTypes.UPDATE_MASTER_DATA_SUCCESS);
export const updateMasterDataFailure = createAction(actionTypes.UPDATE_MASTER_DATA_FAILURE);

export const addMasterData = createAction(actionTypes.ADD_MASTER_DATA_REQUEST);
export const addMasterDataSuccess = createAction(actionTypes.ADD_MASTER_DATA_SUCCESS);
export const addMasterDataFailure = createAction(actionTypes.ADD_MASTER_DATA_FAILURE);

export const deleteMasterData = createAction(actionTypes.DELETE_MASTER_DATA_REQUEST);
export const deleteMasterDataSuccess = createAction(actionTypes.DELETE_MASTER_DATA_SUCCESS);
export const deleteMasterDataFailure = createAction(actionTypes.DELETE_MASTER_DATA_FAILURE);

export const fetchWizardData = createAction(actionTypes.FETCH_WIZARD_DATA_REQUEST);
export const fetchWizardDataSuccess = createAction(actionTypes.FETCH_WIZARD_DATA_SUCCESS);
export const fetchWizardDataFailure = createAction(actionTypes.FETCH_WIZARD_DATA_FAILURE);

export const fetchSkill = createAction(actionTypes.FETCH_SKILL_REQUEST);
export const fetchSkillSuccess = createAction(actionTypes.FETCH_SKILL_SUCCESS);
export const fetchSkillFailure = createAction(actionTypes.FETCH_SKILL_FAILURE);

export const fetchPlants = createAction(actionTypes.FETCH_SKILL_PLANTS_REQUEST);
export const fetchPlantsSuccess = createAction(actionTypes.FETCH_SKILL_PLANTS_SUCCESS);
export const fetchPlantsFailure = createAction(actionTypes.FETCH_SKILL_PLANTS_FAILURE);

export const resetSkill = createAction(actionTypes.RESET_SKILL);
